import React, { Component } from 'react';
import {
  FacebookShareCount,
  PinterestShareCount,
  VKShareCount,
  OKShareCount,
  RedditShareCount,
  TumblrShareCount,
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  RedditShareButton,
  EmailShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  WeiboShareButton,
  PocketShareButton,
  InstapaperShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
  PocketIcon,
  InstapaperIcon,
  WeiboIcon,
} from "react-share"

export default class SocialShareButtons extends Component {
  constructor(props) {
    super(props)
  }

  shareButtons = () => {
    //modified from https://github.com/nygardk/react-share/blob/master/demo/Demo.tsx#L67
    //const shareUrl = window.location.href
    const shareUrl = `http://www.tapheartrate.com`
    const title = "Tap Heartrate"
    const shareImage = `${window.location.origin}/images/logo.png`
    const size = 30 

    return (
      <div className="social_share_button_container">
        <div className="button_wrapper">
          <FacebookShareButton
            url={shareUrl}
            quote={title}
            className="share_button"
          >
            <FacebookIcon size={size} round />
          </FacebookShareButton>

        </div>

        <div className="button_wrapper">
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="share_button"
          >
            <FacebookMessengerIcon size={size} round />
          </FacebookMessengerShareButton>
        </div>

        <div className="button_wrapper">
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <TwitterIcon size={size} round />
          </TwitterShareButton>

        </div>

        <div className="button_wrapper">
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <TelegramIcon size={size} round />
          </TelegramShareButton>

        </div>

        <div className="button_wrapper">
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="share_button"
          >
            <WhatsappIcon size={size} round />
          </WhatsappShareButton>

        </div>

        <div className="button_wrapper">
          <LinkedinShareButton url={shareUrl} className="share_button">
            <LinkedinIcon size={size} round />
          </LinkedinShareButton>
        </div>

        <div className="button_wrapper">
          <PinterestShareButton
            url={String(window.location)}
            media={`${String(window.location)}/${shareImage}`}
            className="share_button"
          >
            <PinterestIcon size={size} round />
          </PinterestShareButton>
        </div>

        <div className="button_wrapper">
          <VKShareButton
            url={shareUrl}
            image={`${String(window.location)}/${shareImage}`}
            className="share_button"
          >
            <VKIcon size={size} round />
          </VKShareButton>
        </div>

        <div className="button_wrapper">
          <OKShareButton
            url={shareUrl}
            image={`${String(window.location)}/${shareImage}`}
            className="share_button"
          >
            <OKIcon size={size} round />
          </OKShareButton>
        </div>

        <div className="button_wrapper">
          <RedditShareButton
            url={shareUrl}
            title={title}
            windowWidth={660}
            windowHeight={460}
            className="share_button"
          >
            <RedditIcon size={size} round />
          </RedditShareButton>
        </div>

        <div className="button_wrapper">
          <TumblrShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <TumblrIcon size={size} round />
          </TumblrShareButton>
        </div>

        <div className="button_wrapper">
          <LivejournalShareButton
            url={shareUrl}
            title={title}
            description={shareUrl}
            className="share_button"
          >
            <LivejournalIcon size={size} round />
          </LivejournalShareButton>
        </div>

        <div className="button_wrapper">
          <MailruShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <MailruIcon size={size} round />
          </MailruShareButton>
        </div>

        <div className="button_wrapper">
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="share_button"
          >
            <EmailIcon size={size} round />
          </EmailShareButton>
        </div>
        <div className="button_wrapper">
          <ViberShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <ViberIcon size={size} round />
          </ViberShareButton>
        </div>

        <div className="button_wrapper">
          <WorkplaceShareButton
            url={shareUrl}
            quote={title}
            className="share_button"
          >
            <WorkplaceIcon size={size} round />
          </WorkplaceShareButton>
        </div>

        <div className="button_wrapper">
          <LineShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <LineIcon size={size} round />
          </LineShareButton>
        </div>

        <div className="button_wrapper">
          <WeiboShareButton
            url={shareUrl}
            title={title}
            image={`${String(window.location)}/${shareImage}`}
            className="share_button"
          >
            <WeiboIcon size={size} round />
          </WeiboShareButton>
        </div>

        <div className="button_wrapper">
          <PocketShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <PocketIcon size={size} round />
          </PocketShareButton>
        </div>

        <div className="button_wrapper">
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="share_button"
          >
            <InstapaperIcon size={size} round />
          </InstapaperShareButton>
        </div>
      </div>
    )
  }


  render = () => this.shareButtons()
}

